var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full relative flex flex-col"},[_c('MessagesFeed',{attrs:{"messages":_vm.messages}}),_c('MessageComposer',{attrs:{"thread":_vm.thread},on:{"send":_vm.sendMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }